import React from 'react'
import type { FormPreviewMock } from './templatePreviewMock.data'
import './FormTemplatePreview.css'

interface FormTemplatePreviewProps {
  preview: FormPreviewMock
}

const FormTemplatePreview: React.FC<FormTemplatePreviewProps> = ({
  preview,
}) => {
  return (
    <div className="form-template-preview">
      <div className="form-template-preview-inner">
        <div className="form-template-preview-header">
          <h2 className="form-template-preview-title">{preview.formTitle}</h2>
        </div>
        <div className="form-template-preview-body">
          <div className="form-template-preview-groups">
            {preview.sections.map((section, idx) => (
              <div key={idx} className="form-template-preview-group">
                <h3 className="form-template-preview-group-title">
                  {section.sectionTitle}
                </h3>
                <div className="form-template-preview-fields">
                  {section.rows.map((row, rowIdx) => (
                    <div key={rowIdx} className="form-template-preview-row">
                      {row.map((field, fieldIdx) => (
                        <div
                          key={fieldIdx}
                          className="form-template-preview-field-cell"
                        >
                          <label className="form-template-preview-label">
                            {field}
                          </label>
                          <div className="form-template-preview-input-line" />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormTemplatePreview
